<template>
  <div>

    <vx-card card-border class="mb-4" title="Anuncios actuales" title-color="dark" collapseAction>      
      <vx-card card-border class="mb-2" v-for="(anuncio, index) in documentos" :key="index">        
        <vs-row>
          <vs-col vs-type="flex" vs-align="center" vs-w="4">
            <span>{{anuncio.fichero}}</span>
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-w="4">
            <img :src="`${baseUrl}/documentos/anuncios/${anuncio.id}___${anuncio.fichero}`" :alt="`${anuncio.fichero}`" class="responsive card-img-top">
          </vs-col>                    
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="4">
            <feather-icon icon="Trash2Icon" class="mr-4 hover:text-primary cursor-pointer" @click="confirmarBorrarDocumento(index, anuncio.id, anuncio.fichero)"/>
          </vs-col>
        </vs-row>    
      </vx-card>
      <div class="vx-row w-full" v-if="documentos === undefined || documentos.length === 0">
        <div class="vx-col w-full">
          <vs-alert color="danger" icon-pack="feather" icon="icon-info">
            <span>No existe ningún anuncio actualmente.</span>
          </vs-alert>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-2" title="Añadir nuevos anuncios" title-color="dark" collapseAction>
      <div class="vx-row mb-4" v-for="(documento, index) in fileRecordsForUpload" :key="index">
        <div class="vx-col sm:w-1/3 w-full">
          <div>
            <span>Nombre del fichero:</span>
          </div>
          <div>
            <vs-input class="w-full" name="fichero" v-model="fileRecordsForUpload[index].file.name" disabled />
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <div>
            <span class="campoObligatorio">Tipo documento:</span>
          </div>
          <div>
            <v-select class="w-full"               
              v-model="fileRecordsForUpload[index].tipoDocumento"
              :options="valTiposDocumentos" 
              label="nombre"
              :reduce="id => id.id" 
            />
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <div>
            <span>Descripción:</span>
          </div>
          <div>
            <vs-input class="w-full" name="descripcion" v-model="fileRecordsForUpload[index].descripcion" @input="v => { fileRecordsForUpload[index].descripcion = v.toUpperCase()}" />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <VueFileAgent 
            ref="vueFileAgent"
            v-model="fileRecords"
            :deletable="true"
            :accept="'.png,.jpg,.jpeg'"
            :helpText="'Seleccione ficheros'"
            @select="vueFileAgentFilesSelected($event)"
            @beforedelete="vueFileAgentOnBeforeDelete($event)"
            @delete="vueFileAgentFileDeleted($event)"
          ></VueFileAgent>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
          </div>
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>
import valTiposDocumentosStore from '@/store/configuracion/val-tipos-documentos/index.js'
import anunciosStore from '@/store/configuracion/anuncios/index.js'

import Vue from 'vue'

import vSelect from 'vue-select'

// Carga de ficheiros
import VueFileAgent from 'vue-file-agent'
Vue.use(VueFileAgent)
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'

import VueLink from 'vue-link'

export default {
  name: 'AnunciosSubirFotos',
  components: {
    VueFileAgentStyles,
    VueLink,
    vSelect
  },
  props: {

  },
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      documentos: [],
      valTiposDocumentos: [],
      // VueFileAgent
      fileRecords: [],
      fileRecordsForUpload: []
    }
  },
  computed: {
    validateForm () {      
      if (this.fileRecordsForUpload.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {    
    showSuccess (titulo, texto) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showError (titulo, error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: titulo,
        text: error
      })
    },
    reset_data () {
      this.$router.push({name: 'anuncios'})
    },
    vueFileAgentDeleteUploadedFile (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord)
    },
    vueFileAgentFilesSelected (fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)
    },
    vueFileAgentOnBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
        this.fileRecords.splice(i, 1)
      } else {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
      }
    },
    vueFileAgentFileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
        this.fileRecords.splice(i, 1)
      } else {
        this.vueFileAgentDeleteUploadedFile(fileRecord)
      }
    },
    confirmarBorrarDocumento (index, id, documento) {
      this.documento = { index, id }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ATENCIÓN: no se podrá recuperar!',
        text: `¿Seguro que desea eliminar el anuncio "${documento}"?`,
        accept: this.borrarDocumento,
        parameters: id,
        acceptText: 'Eliminar'
      })
    },
    async borrarDocumento (id) {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      await this.$store.dispatch('anunciosStore/deleteDocumentos', id)
        .then(() => {
          this.inicializar('DOCUMENTO ELIMINADO', 'El documento ha sido eliminado correctamente.')
        })
        .catch((error) => {
          this.showError('ERROR AL ELIMINAR EL DOCUMENTO', error)
        })
    },
    async guardar () {
      if (!this.validateForm) return
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      
      const formData = new FormData()
      const datos = []

      // Revisamos se hai ficheiros para subir
      if (Array.isArray(this.fileRecordsForUpload) && this.fileRecordsForUpload.length > 0) {
        this.fileRecordsForUpload.forEach(element => {  // recorremos os ficheiros a subir
          datos.push(JSON.stringify({ 
            //TODO revisar este objeto           
            'nombreFichero': element.file.name, 
            'tipoDocumento': 'ANUNCIO', 
            'descripcion': element.descripcion === undefined ? null : element.descripcion,
            'categoria': 'anuncio'
          }))
          formData.append('ficheiros[]', element.file)    // gardamos o ficheiro físico para enviar
        })
      }
      formData.append('datos[]', datos)

      await this.$store.dispatch('anunciosStore/addDocumentos', formData)
        .then(() => {          
          this.inicializar('DOCUMENTOS GUARDADOS', 'Los documentos han sido guardados correctamente.')
        })
        .catch((error) => {
          this.showError('ERROR GUARDANDO DOCUMENTOS', error)
        })
    },
    async inicializar (titulo, texto) {
      this.fileRecords = []
      this.fileRecordsForUpload = []
            
      await this.$store.dispatch('anunciosStore/getDocumentos')
        .then((response) => {
          this.documentos = response
          this.showSuccess(titulo, texto)
        })
        .catch((error) => {
          this.showError('ERROR ACTUALIZANDO DATOS', error)
        })
    }
  },
  async created () {
    //this.$vs.loading('material') // Mostramos unha animación de 'cargando...'    
     
    if (!valTiposDocumentosStore.isRegistered) {
      this.$store.registerModule('valTiposDocumentosStore', valTiposDocumentosStore)
      valTiposDocumentosStore.isRegistered = true
    }
       
    if (!anunciosStore.isRegistered) {
      this.$store.registerModule('anunciosStore', anunciosStore)
      anunciosStore.isRegistered = true
    }
    await this.$store.dispatch('anunciosStore/getDocumentos')
    this.anuncios = JSON.parse(JSON.stringify(this.$store.state.anunciosStore.anuncios))
    this.anuncios.length > 0 ? this.documentos = this.anuncios : this.documentos = []   

    
    await this.$store.dispatch('valTiposDocumentosStore/getTiposDocumentos')
      .then(() => {
        // Recorremos os tipo de documentos e se están activos engadímolas ao combo
        this.$store.state.valTiposDocumentosStore.tiposDocumentos.forEach(element => {
          if (element.activo && element.categoria === 'ANUNCIO') this.valTiposDocumentos.push(element)
        })
      })
      .catch((error) => {
        console.log(error)
      })  

    //this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
  }
}
</script>

